import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './ServicesBanner.css';

const ServicesBanner = () => {
  const { t } = useLanguage();
  const services = [
    {
      title: <>{t.servicesBanner.card1Title} <span className="services-banner-fox__title-light">{t.servicesBanner.card1TitleLight}</span></>,
      description: <>{t.servicesBanner.card1Desc} <strong>{t.servicesBanner.card1DescBold}</strong>{t.servicesBanner.card1DescEnd}</>,
      image: '/img/fox_2.png',
      link: '#ppc',
      pill: t.servicesBanner.card1Pill
    },
    {
      title: <><span className="services-banner-fox__title-light">{t.servicesBanner.card2TitleLight}</span> {t.servicesBanner.card2Title}</>,
      description: <>{t.servicesBanner.card2Desc} <strong>{t.servicesBanner.card2DescBold}</strong>{t.servicesBanner.card2DescEnd}</>,
      image: '/img/fox_1.png',
      link: '#produktbilder',
      pill: t.servicesBanner.card2Pill
    },
    {
      title: <><span className="services-banner-fox__title-light">{t.servicesBanner.card3TitleLight}</span> {t.servicesBanner.card3Title}</>,
      description: <>{t.servicesBanner.card3Desc} <strong>{t.servicesBanner.card3DescBold}</strong>{t.servicesBanner.card3DescEnd}</>,
      image: '/img/fox_3.png',
      link: '#seo',
      pill: t.servicesBanner.card3Pill
    }
  ];

  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const gridReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="services-banner-fox">
      <div className="services-banner-fox__bg-grid"></div>
      <div className="services-banner-fox__bg-orb services-banner-fox__bg-orb--1"></div>
      <div className="services-banner-fox__bg-orb services-banner-fox__bg-orb--2"></div>
      <div className="services-banner-fox__bg-orb services-banner-fox__bg-orb--3"></div>
      
      <div className="services-banner-fox__container">
        <div ref={headerReveal.ref} className={`services-banner-fox__header reveal ${headerReveal.isRevealed ? 'reveal--visible' : ''}`}>
          <span className="services-banner-fox__label reveal-child">{t.servicesBanner.label}</span>
          <h2 className="services-banner-fox__title reveal-child">
            {t.servicesBanner.title} <span className="services-banner-fox__title-gradient">{t.servicesBanner.titleHighlight}</span>.
          </h2>
          <p className="services-banner-fox__subtitle reveal-child">
            {t.servicesBanner.subtitle} <span className="services-banner-fox__subtitle-highlight">{t.servicesBanner.subtitleHighlight}</span>.
          </p>
        </div>
        <div ref={gridReveal.ref} className={`services-banner-fox__grid reveal ${gridReveal.isRevealed ? 'reveal--visible' : ''}`}>
          {services.map((service, index) => (
            <a 
              href={service.link} 
              key={index} 
              className="services-banner-fox__card reveal-child"
            >
              <div className="services-banner-fox__card-content">
                <span className="services-banner-fox__pill">{service.pill}</span>
                <h3 className="services-banner-fox__card-title">{service.title}</h3>
                <p className="services-banner-fox__card-description">{service.description}</p>
              </div>
              <div className="services-banner-fox__card-image-wrapper">
                <img 
                  src={service.image} 
                  alt={service.pill}
                  className="services-banner-fox__card-image"
                  width={300}
                  height={200}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </a>
          ))}
          <div className="services-banner-fox__divider services-banner-fox__divider--1">
            <span>+</span>
          </div>
          <div className="services-banner-fox__divider services-banner-fox__divider--2">
            <span>+</span>
          </div>
        </div>
        <div className="services-banner-fox__cta-wrapper">
          <a href="https://meetings-eu1.hubspot.com/michael-wenger?uuid=9cf1d252-81d9-4d0a-ac62-21972be61c70" target="_blank" rel="noopener noreferrer" className="btn-fox btn-fox--outline btn-fox--medium">
            {t.servicesBanner.cta}
            <span className="btn-fox__icon">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesBanner;
